<template>
  <nav class="navbar navbar-expand-md navbar-light bg-white shadow-sm">
    <div class="container">
      <RouterLink class="navbar-brand" to="/member">高地トレーニングStudio. Green・Terrace</RouterLink>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent">
        <span class="navbar-toggler-icon"/>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <!-- Left Side Of Navbar -->
        <ul class="navbar-nav mr-auto">

        </ul>

        <!-- Right Side Of Navbar -->
        <ul dusk="nav-menu" class="navbar-nav ml-auto">
          <li class="nav-item" v-if="!isLogin">
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
              <RouterLink class="nav-link" to="login">
                ログイン
              </RouterLink>
            </div>
          </li>
          <li v-if="isLogin" class="nav-item dropdown">
            <a id="navbarDropdown" class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ user.name }}<span class="caret"/>
            </a>

            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
              <a dusk="nav-menu-logout" class="dropdown-item" href v-on:click.prevent="logout">
                ログアウト
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Navbar",
  data: function () {
    return {
      APP_NAME: document.title,
    }
  },
  computed: {
    isLogin() {
      return this.$store.getters['auth/check'];
    },
    user() {
      return this.$store.getters['auth/user'];
    },
    username() {
      return this.$store.getters['auth/username'];
    }
  },
  methods: {
    async logout() {
      await this.$store.dispatch('auth/logout');

      this.$router.push('/member/login');
    }
  }
}
</script>

<style scoped>

</style>
